module.exports = __webpack_public_path__ + "static/media/rta.d8db0209.svg";